import { Table } from "@telluscompany/design-system";
import { useSearchParams } from "react-router-dom";
import type { ComponentType, Dispatch, SetStateAction } from "react";

import type { GeneralDashboardTableSort } from "../utils/generalDashboardTableSort";

import { useUpdateTableUserPreferences } from "@shared/hooks";
import type { PaginationMeta } from "@shared/api";
import { Gs3TablePaginator } from "@shared/components";
import {
  EMPTY_PAGINATION_META,
  type PageSize,
} from "@shared/constants/pagination.constants";
import { useUserContext } from "@shared/contexts";

export type GeneralDashboardTableColumn = {
  key: string;
  label: string;
  minWidth?: string;
  sortType?: "text" | "number" | "date";
};

type GeneralDashboardPaginatedTableProps = {
  tableId: string;
  tableColumns: GeneralDashboardTableColumn[];
  tableData: { [key: string]: unknown; color?: string }[];
  meta?: PaginationMeta;
  isLoading?: boolean;
  onPageChange: (page: number) => void;
  onLimitChange: (limit: PageSize) => void;
  onSortChange?: Dispatch<SetStateAction<GeneralDashboardTableSort | null>>;
  tableFilter?: ComponentType;
  filterButtonText?: string;
};

export const GeneralDashboardPaginatedTable = ({
  tableId,
  tableColumns,
  tableData,
  meta,
  isLoading = false,
  onPageChange,
  onLimitChange,
  onSortChange,
  tableFilter,
  filterButtonText,
}: GeneralDashboardPaginatedTableProps) => {
  const { user: me } = useUserContext();
  const updateTableUserPreferences = useUpdateTableUserPreferences(me?.userPreferences);

  return (
    <div className="general-dashboard-paginated-table">
      <Table
        userId={me?.id ?? ""}
        tableId={tableId}
        usersPreferencesFromServer={me?.userPreferences}
        updateUsersPreferencesOnServer={updateTableUserPreferences}
        useSearchParamsHook={useSearchParams}
        setSelectedSortKey={onSortChange}
        draggable
        enableTableColumnsSelector
        handleClickRow={() => {}}
        tableColumns={tableColumns}
        tableData={tableData}
        TableFilter={tableFilter}
        filterButtonText={filterButtonText}
        TablePaginator={
          <Gs3TablePaginator
            meta={meta ?? EMPTY_PAGINATION_META}
            useSearchParamsHook={useSearchParams}
            onPageChange={onPageChange}
            onLimitChange={(limit) => onLimitChange(limit as PageSize)}
            isLoading={isLoading}
          />
        }
      />
    </div>
  );
};
